/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_HeadingInputs */

const en_homepage_listen_in_heading = /** @type {(inputs: Homepage_Listen_In_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People love Listening in...`)
};

const es_homepage_listen_in_heading = /** @type {(inputs: Homepage_Listen_In_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A la gente le encanta escuchar mientras...`)
};

/**
* | output |
* | --- |
* | "People love Listening in..." |
*
* @param {Homepage_Listen_In_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_heading = /** @type {((inputs?: Homepage_Listen_In_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_heading(inputs)
	return en_homepage_listen_in_heading(inputs)
});